export const ClockIcon = ({
  width = 13,
  height = 13,
  className,
  title = "clock",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path
        d="M6.5 11.375C9.19239 11.375 11.375 9.19239 11.375 6.5C11.375 3.80761 9.19239 1.625 6.5 1.625C3.80761 1.625 1.625 3.80761 1.625 6.5C1.625 9.19239 3.80761 11.375 6.5 11.375Z"
        stroke="currentColor"
        strokeWidth="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5 3.79167V6.5L8.39583 7.58333"
        stroke="currentColor"
        strokeWidth="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
